import React from "react";
import {Button, Checkbox} from "@material-ui/core";

import MUIDataTable from "mui-datatables";
import 'moment/locale/de';
import {makeStyles} from "@material-ui/core/styles";

const us = makeStyles((theme) => ({
    buttons: {
        '& > *': {
            margin: theme.spacing(1),
        },
    },
}));

export default function TableComponent({data}) {
    const classes = us();

    const columns = [
        {
            name: "first_name",
            label: "Vorname",
            options: {
                filter: true,
                sort: true,
            },
        },
        {
            name: "last_name",
            label: "Nachname",
            options: {
                filter: true,
                sort: true,
            },
        },
        {
            name: "email",
            label: "E-mail",
            options: {
                filter: true,
                sort: true
            },
        },
        {
            name: "phone",
            label: "Telefon",
            options: {
                filter: true,
                sort: true
            },
        },
        {
            name: "cv_url",
            label: "CV",
            options: {
                filter: false,
                sort: false,
                customBodyRenderLite: (dataIndex) => {
                    return (
                        <Button
                            variant="contained"
                            size="medium"
                            color="secondary"
                            target={'_blank'}
                            href={data[dataIndex].cv_url}>
                            CV
                        </Button>
                    )
                }
            }
        },
        {
            name: "extra_files",
            label: "Extra Dateien",
            options: {
                filter: false,
                sort: false,
                customBodyRenderLite: (dataIndex) => {
                    const extra_files = data[dataIndex].extra_files;
                    return (<div className={classes.buttons}>
                        {extra_files.map((e, i) => <Button
                                variant="contained"
                                size="medium"
                                color="secondary"
                                my={1}
                                target={'_blank'}
                                href={e.document_url}>
                                Anhang #{i + 1}
                            </Button>
                        )}
                    </div>)
                },
            },
        },
    ];

    return (<MUIDataTable
        data={data}
        columns={columns}
        components={{Checkbox: (props) => <Checkbox  {...props} color={"secondary"}/>}}
        options={{
            selectableRowsHideCheckboxes: true, print: false, textLabels: {
                body: {
                    noMatch: "Entschuldigung, keine übereinstimmenden Datensätze gefunden",
                    toolTip: "Sortieren",
                    columnHeaderTooltip: column => `Nach ${column.label} sortieren`,
                },
                pagination: {
                    next: "Nächste Seite",
                    previous: "Vorherige Seite",
                    rowsPerPage: "Einträgen pro Seite:",
                    displayRows: "von",
                },
                toolbar: {
                    search: "Suche",
                    downloadCsv: "CSV Herunterladen",
                    print: "Drucken",
                    viewColumns: "Siehe Spalten",
                    filterTable: "Filtertabelle",
                },
                filter: {
                    all: "Alle",
                    title: "FILTER",
                    reset: "ZURÜCKSETZEN",
                },
                viewColumns: {
                    title: "Spalten anzeigen",
                    titleAria: "Tabellenspalten anzeigen",
                },
                selectedRows: {
                    text: "Einträge(n) ausgewählt",
                    delete: "Löschen",
                    deleteAria: "Ausgewählte Einträgen löschen",
                },
            },
            onDownload: (buildHead, buildBody, columns, data) => {
                const newColNumber = Math.max(...data.map(d => d.data[5].length));

                const newCols = []
                for (let i = 1; i <= newColNumber; i++) {
                    newCols.push({...columns[5], name: `extra_files_${i}`, label: `Extra Datei ${i}`})
                }

                delete columns[5];
                Array.prototype.push.apply(columns, newCols);

                data.map(d => d.data[5].map(a => d.data.push(a.document_url)))
                data.map(d => delete d.data[5])

                return `${buildHead(columns)}${buildBody(data)}`.trim()
            }
        }}
    />);
}



